import { ejsRoms, zipEntryNames } from "../emulator/ejs";
import { romBaseName } from "../emulator/saves";
import { readIdbfs, type StoredFile } from "./idbfs";

// Saves this browser holds, read without booting an emulator (as
// localLibrary does for games): mGBA's /data (saves/<base>.sav,
// states/<base>.ssN) and EmulatorJS's /data/saves.

/** mGBA's battery saves and save states, by mGBA's file names (<base>.sav, <base>.ssN). */
export async function mgbaLocalSaves(): Promise<StoredFile[]> {
  const [saves, states] = await Promise.all([readIdbfs("/data", "/data/saves/"), readIdbfs("/data", "/data/states/")]);
  return [...saves, ...states];
}

// EmulatorJS names a save after the file it ran: the game's name with
// characters it dislikes removed or, for a zip, the ROM inside.
async function ejsSaveBases(game: string): Promise<Set<string>> {
  const bases = new Set([romBaseName(game), romBaseName(game.replace(/[#<$+%>!`&*'|{}/\\?"=@:^\r\n]/g, "").trim())]);
  if (/\.zip$/i.test(game)) {
    const blob = await ejsRoms.get(game);
    if (blob)
      for (const entry of await zipEntryNames(blob)) bases.add(romBaseName(entry.slice(entry.lastIndexOf("/") + 1)));
  }
  return bases;
}

/** EmulatorJS's game save (N64 cartridge) for each of these games that has one. */
export async function ejsLocalSaves(games: string[]): Promise<Map<string, StoredFile>> {
  const files = await readIdbfs("/data/saves", "/data/saves/");
  const found = new Map<string, StoredFile>();
  for (const game of games) {
    const bases = await ejsSaveBases(game).catch(() => new Set([romBaseName(game)]));
    const matches = files.filter((f) => bases.has(romBaseName(f.name))).sort((a, b) => b.updatedAt - a.updatedAt);
    if (matches.length) found.set(game, matches[0]);
  }
  return found;
}
